import React from 'react';
import '../App.css';

const Searchbar = ({ text, value, onChange }) => {
  return ( // Renderiza el input
    <input
      className="searchbar"
      type="text"
      placeholder={text}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  );
};

export default Searchbar;